export default __webpack_public_path__ + "static/media/black-gift.0500505a.png";